export default __webpack_public_path__ + "media/images/icons/app-7-5d7603fe664d3c2df2fc39223359781a.png";